// Cómo se reconoce que un trozo `lazy` no ha llegado. Lo usa `components/TrozoQueNoLlega.jsx`.
//
// ESTÁ APARTE PARA PODER PROBARLO EN NODE (`scripts/prueba_avisos.mjs`): el componente lleva
// JSX y node no lo lee. Y conviene probarlo, porque cada navegador lo dice a su manera y ninguna
// de las tres sale en el ordenador de quien programa:
//
//   · webpack (lo que construye esta web):   name "ChunkLoadError", «Loading chunk 123 failed»
//                                            o «Loading CSS chunk 45 failed»
//   · Chrome con módulos nativos:            «Failed to fetch dynamically imported module»
//   · Safari, el del iPhone:                 «Importing a module script failed»

export function esTrozoQueNoLlega(error) {
  const nombre = String(error?.name || "");
  const dice = String(error?.message || "");
  return nombre === "ChunkLoadError"
    || /Loading (CSS )?chunk [\w-]+ failed/i.test(dice)
    || /dynamically imported module|Importing a module script failed/i.test(dice);
}
